// src/i18n.js
const translations = {
  en: {
    noTeamSelected: 'No team selected. Please join or create a team first.',
    loadingTeam: 'Loading team…',
    noMembersYet: 'No members yet',
    noTeams: 'No teams yet',
    learnReact: 'learn react',
    appTitle: 'Amazing Ansrace',
    toggleNavigation: 'Toggle navigation',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signInWithGoogle: 'Sign in with Google',
    adminDashboard: 'Dashboard',
    adminMap: 'Map',
    adminLogin: 'Admin login',
    signOut: 'Sign out',
    map: 'Map',
    addSite: 'Add Site',
    siteTitle: 'Title',
    siteLat: 'lat',
    siteLng: 'lng',
    siteDescription: 'Description',
    sites: 'Sites',
    tasks: 'Tasks',
    manageTasks: 'Manage tasks',
    close: 'Close',
    editTask: 'Edit task',
    addTask: 'Add new task',
    taskTitle: 'Task title',
    taskDescription: 'Task description',
    proofType: 'Proof type',
    points: 'Points',
    save: 'Save',
    cancel: 'Cancel',
    text: 'Text',
    photo: 'Photo',
    remove: 'Remove',
    pendingSubmissions: 'Pending Submissions',
    approve: 'Approve',
    reject: 'Reject',
    liveScoreboard: 'Live Scoreboard',
    team: 'Team',
    site: 'Site',
    task: 'Task',
    proof: 'Proof',
    members: 'Members',
    livePlayerMap: 'Live Player Map',
    trails: 'Trails',
    teamColors: 'Team Colors',
    scoreboard: 'Scoreboard',
    playerMap: 'Player Map',
    createTeam: 'Create Team',
    joinTeam: 'Join Team',
    logout: 'Logout',
    loggedin: 'Logged in as',
    login: 'Login',
    player: 'Player',
    approved: 'Approved',
    pending: 'Pending',
    selectPhoto: 'Select photo',
    photoSubmitted: 'Photo submitted for review',
    uploadFailed: 'Upload failed',
    uploading: 'Uploading…',
    submit: 'Submit',
    enterProofText: 'Enter proof (short text):',
    editSite: 'Edit site',
    createOrJoinTeam: 'Create or Join Team',
    teamName: 'Team name',
    playerName: 'Your name (visible to team)',
    joinOrCreate: 'Join / Create',
    processing: 'Processing…',
    updated: 'Updated',
    settings: 'Settings',
    language: 'Language',
    themeMode: 'Theme',
    autoMode: 'Auto',
    lightMode: 'Light',
    darkMode: 'Dark',
  },
  fi: {
    noTeamSelected: 'Joukkuetta ei valittu. Liity tai luo joukkue ensin.',
    loadingTeam: 'Ladataan joukkuetta…',
    noMembersYet: 'Ei jäseniä vielä',
    noTeams: 'Ei joukkueita vielä',
    learnReact: 'opettele reactia',
    appTitle: 'Amazing Ansrace',
    toggleNavigation: 'Vaihda navigointia',
    email: 'Sähköposti',
    password: 'Salasana',
    signIn: 'Kirjaudu sisään',
    signInWithGoogle: 'Kirjaudu Googlella',
    adminDashboard: 'Hallintapaneeli',
    adminMap: 'Kartta',
    adminLogin: 'Admin-kirjautuminen',
    signOut: 'Kirjaudu ulos',
    map: 'Kartta',
    addSite: 'Lisää kohde',
    siteTitle: 'Nimi',
    siteLat: 'lat',
    siteLng: 'lng',
    siteDescription: 'Kuvaus',
    sites: 'Kohteet',
    tasks: 'Tehtävät',
    manageTasks: 'Hallinnoi tehtäviä',
    close: 'Sulje',
    editTask: 'Muokkaa tehtävää',
    addTask: 'Lisää uusi tehtävä',
    taskTitle: 'Tehtävän nimi',
    taskDescription: 'Tehtävän kuvaus',
    proofType: 'Todistetyyppi',
    points: 'Pisteet',
    save: 'Tallenna',
    cancel: 'Peruuta',
    text: 'Teksti',
    photo: 'Kuva',
    remove: 'Poista',
    pendingSubmissions: 'Hyväksymistä odottavat suoritukset',
    approve: 'Hyväksy',
    reject: 'Hylkää',
    liveScoreboard: 'Live-pistetaulukko',
    team: 'Joukkue',
    site: 'Kohde',
    task: 'Tehtävä',
    proof: 'Todiste',
    members: 'Jäsenet',
    livePlayerMap: 'Live-pelaajakartta',
    trails: 'Reitit',
    teamColors: 'Joukkueiden värit',
    scoreboard: 'Pistetaulukko',
    playerMap: 'Pelaajakartta',
    createTeam: 'Luo joukkue',
    joinTeam: 'Liity joukkueeseen',
    logout: 'Kirjaudu ulos',
    login: 'Kirjaudu sisään',
    loggedin: 'Kirjautuneena',
    player: 'Pelaaja',
    approved: 'Hyväksytty',
    pending: 'Odottaa',
    selectPhoto: 'Valitse kuva',
    photoSubmitted: 'Kuva lähetetty tarkistettavaksi',
    uploadFailed: 'Lähetys epäonnistui',
    uploading: 'Lähetetään…',
    submit: 'Lähetä',
    enterProofText: 'Kirjoita todiste (lyhyt teksti):',
    editSite: 'Muokkaa kohdetta',
    createOrJoinTeam: 'Lisää / Liity joukkueeseen',
    teamName: 'Joukkueen nimi',
    playerName: 'Oma nimi (näkyy joukkueessa)',
    joinOrCreate: 'Liity / Luo',
    processing: 'Käsitellään…',
    updated: 'Päivitetty',
    settings: 'Asetukset',
    language: 'Kieli',
    themeMode: 'Teema',
    autoMode: 'Automaattinen',
    lightMode: 'Vaalea',
    darkMode: 'Tumma',
  }
};


function detectDefaultLang() {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem('lang');
    if (stored) return stored;
    const navLang = (window.navigator.language || '').toLowerCase();
    if (navLang.startsWith('fi')) return 'fi';
    if (navLang.startsWith('en')) return 'en';
  }
  return 'en';
}

let currentLang = detectDefaultLang();

export function t(key) {
  return translations[currentLang][key] || key;
}

export function setLang(lang) {
  if (translations[lang]) {
    currentLang = lang;
    if (typeof window !== 'undefined') window.localStorage.setItem('lang', lang);
  }
}

export function getLang() {
  return currentLang;
}

export default translations;
